import { EquipmentCalculatorSectionKey } from "@/composables/scenarioCalculations/calculationTypes";
import { Gas_Compressibility_Options_Enum } from "gql/api";
import { Severity, type ValidationRuleGenerator } from "../scenarioValidator";

export const gasCompositionChecksNames = [
  "peng_robinson_requires_gas_composition"
] as const;

// Peng Robinson is compositional (PVT!B77:AP91) — with no gas percentages
// entered it silently returns 0 for gas Z/density/volume factor/viscosity
// instead of erroring, so flag the combination directly instead of letting
// it produce unusable sizing results.
export const gasCompositionChecks: ValidationRuleGenerator = ({
  wellProperties,
  correlations
}) => {
  const totalGasPercentage =
    (wellProperties.value?.c1_methane_percent || 0) +
    (wellProperties.value?.c2_ethane_percent || 0) +
    (wellProperties.value?.c3_propane_percent || 0) +
    (wellProperties.value?.ic4_isobutene_percent || 0) +
    (wellProperties.value?.nc4_butane_percent || 0) +
    (wellProperties.value?.ic5_isopentane_percent || 0) +
    (wellProperties.value?.nc5_bentane_percent || 0) +
    (wellProperties.value?.c6_hexane_percent || 0) +
    (wellProperties.value?.c7_heptane_percent || 0) +
    (wellProperties.value?.n2_percent || 0) +
    (wellProperties.value?.co2_percent || 0) +
    (wellProperties.value?.h2s_percent || 0) +
    (wellProperties.value?.o2_percent || 0) +
    (wellProperties.value?.ar_percent || 0);

  return [
    {
      name: "peng_robinson_requires_gas_composition",
      message:
        'Peng Robinson gas compressibility requires a gas composition. Turn on "Specify Gas Percentages" in Gas Properties, or choose a different Gas Compressibility correlation.',
      severity: Severity.error,
      isActive:
        correlations.value?.gas_compressibility ===
        Gas_Compressibility_Options_Enum.PengRobinson,
      isInvalid: totalGasPercentage === 0,
      rulePlacement: EquipmentCalculatorSectionKey.GAS_PROPERTIES
    }
  ];
};
